export const userActivityLogColumns = [
  { key: 'createdAt', title: 'Time' },
  { key: 'logDescription', title: 'Log Description' },
  { key: 'email', title: 'email' },
  { key: 'name', title: 'Name' },
  { key: 'entityType', title: 'Element' },
  { key: 'activityType', title: 'Activity Type' },
];
